import React from 'react';
import {FormattedMessage} from 'react-intl';
import DecorateContainer from '../../utils/DecoratedContainer';
import i18nLabels from './Price.i18n';

const Price = ({intl, price, children, className = '', numberClass = '', mthClass, mth = false, showFree}) => {
    let _price = price === '0' || price === 0 ? 0 : price || children;
    if (typeof _price === 'number') {
        if (_price % 1 === 0) _price = Math.round(_price);
        else _price = _price.toFixed(2);
    }
    return (
        <span className={`global-price ${className}`}>
            {showFree ? (
                <span className={numberClass}>{intl.messages.free}</span>
            ) : (
                <FormattedMessage
                    id='price'
                    defaultMessage={intl.messages.RM}
                    values={{
                        price: <span className={numberClass}>{_price}</span>,
                        mth: <span className={mthClass}>{mth ? intl.messages.mth : ''}</span>
                    }}
                />
            )}
        </span>
    );
};

export default DecorateContainer(Price, i18nLabels);
